var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"has-background":true,"contained":true}},[_c('v-card-title',[_c('h2',{staticClass:"text-light d-inline-block"},[_c('font-awesome-icon',{staticStyle:{"font-size":"1rem"},attrs:{"icon":"fa-regular fa-box-archive"}}),_vm._v(" Services - "+_vm._s(_vm.funeralHome)+" ")],1)]),_c('services-table',{attrs:{"home_id":_vm.home_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }